import { FoodTurkeyIcon } from './FoodTurkeyIcon';

/**
 * author: Colton Wiscombe
 * id D5900301-8742-4D92-8E56-525DCDE97E0F
 * name food-turkey
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-turkey.svg
 * tags
 * - Food / Drink 
 * - Holiday 
 */
export const ThanksgivingIcon = FoodTurkeyIcon;
export default ThanksgivingIcon